import BetsApi from './BetsApi';

export default BetsApi;
